import { render, staticRenderFns } from "./stockManagementDetail.vue?vue&type=template&id=202daec1&scoped=true"
import script from "./stockManagementDetail.vue?vue&type=script&lang=js"
export * from "./stockManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./stockManagementDetail.vue?vue&type=style&index=0&id=202daec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202daec1",
  null
  
)

export default component.exports